// SAB-447: sticky bottom CTA bar — mobile only (sm:hidden).
//
// Always visible at <768px so converting never requires scrolling. The fixed
// position + safe-area-inset-bottom padding handles iPhone home-indicator
// space. Hidden at md+ — desktop CTAs in the nav + final CTA cover that lane.
//
// Copy is intentionally brief to fit a single line at 375px width without
// pushing the button off-screen. Neutral launch statement, no date or offer.
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { trackEvent } from '@/lib/analytics';

export function MobileStickyCta() {
  const trackClick = () =>
    trackEvent('homepage_browse_leagues_click', {
      source: 'homepage',
      placement: 'mobile_sticky_cta',
    });

  return (
    <div
      className="sm:hidden fixed bottom-0 left-0 right-0 z-40 border-t border-border bg-background/95 backdrop-blur-md"
      style={{
        paddingBottom: 'env(safe-area-inset-bottom)',
      }}
      role="region"
      aria-label="Persistent league signup"
    >
      <div className="flex items-center justify-between gap-3 px-4 py-2.5">
        <div className="min-w-0 flex-1 flex items-center gap-1.5 flex-wrap">
          <span className="text-[12px] font-display font-bold text-foreground leading-tight">
            Launching NFL Season 2026
          </span>
        </div>
        <Button asChild size="sm" variant="default" className="text-[13px] flex-none">
          <Link to="/nfl/leagues/browse" onClick={trackClick}>
            Browse Leagues →
          </Link>
        </Button>
      </div>
    </div>
  );
}

export default MobileStickyCta;
